import type { ReactNode } from "react";
import { Copy } from "./Copy";

export function Code({
  fname,
  badge,
  copyText,
  children,
}: {
  fname?: string;
  badge?: string;
  copyText?: string;
  children: ReactNode;
}) {
  return (
    <div className="code-window">
      <div className="code-bar">
        <div className="dots">
          <i />
          <i />
          <i />
        </div>
        {fname ? <span className="fname">{fname}</span> : null}
        {badge ? <span className="badge">{badge}</span> : null}
        {copyText ? <Copy text={copyText} /> : null}
      </div>
      <pre className="code">{children}</pre>
    </div>
  );
}
